const constants = {
    MY_ORDER:"My Order",
    ORDER: "ORDER #",
    SIZE: "Size: ",
    QTY: "Qty: ", 
    RS: "Rs "
}
export default constants;